var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeepMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 161,
    viewBox: "0 0 96 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.7698 157.923V142.45C61.7698 141.812 61.5138 141.201 61.0582 140.751C60.6026 140.3 59.9847 140.047 59.3404 140.047H32.0582C31.2447 140.044 30.4397 139.882 29.6893 139.571C28.939 139.261 28.2578 138.807 27.6848 138.235C27.1118 137.664 26.6582 136.987 26.3498 136.242C26.0414 135.498 25.8843 134.701 25.8875 133.896V111.359C25.9152 110.835 25.7687 110.316 25.4704 109.882C25.1721 109.448 24.7384 109.123 24.2355 108.956L17.6033 106.769C17.127 106.612 16.6923 106.351 16.3308 106.006C15.9694 105.661 15.6904 105.24 15.514 104.775C15.377 104.285 15.3494 103.771 15.4333 103.269C15.5172 102.767 15.7105 102.289 15.9999 101.868L25.7175 85.6977C25.7175 85.5536 25.7175 85.5536 25.7175 85.5536C25.7886 85.4071 25.8456 85.2542 25.8875 85.0971C25.8993 84.9371 25.8993 84.7765 25.8875 84.6165C25.8981 84.569 25.8981 84.5199 25.8875 84.4724C25.8319 76.8358 27.6773 69.303 31.2609 62.5384H64.6166M106.252 157.923V118.158C106.238 118.047 106.238 117.934 106.252 117.822C106.24 117.638 106.24 117.453 106.252 117.269C106.34 117.099 106.446 116.937 106.568 116.789C106.616 116.695 106.673 116.607 106.738 116.524C112.111 111.04 116.038 104.332 118.17 96.9926C120.303 89.6529 120.577 81.9069 118.968 74.4378C118.072 70.279 116.607 66.2772 114.627 62.5384H80.0012",
    stroke: "#26FF7B",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8466 81H82.2312C86.0972 81 89.2312 84.134 89.2312 88V99.4615",
    stroke: "#26FF7B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7701 71.7692H62.3855C58.5195 71.7692 55.3855 74.9032 55.3855 78.7692V90.2307",
    stroke: "#26FF7B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3086 102.538V16.3846",
    stroke: "#26FF7B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8249 47.1538L72.3087 47.1538V40.116C72.3087 36.2702 73.9327 32.5819 76.8236 29.8625C79.7144 27.1431 83.6353 25.6153 87.7236 25.6153L109.232 25.6153V32.6531C109.232 36.4976 107.609 40.1848 104.72 42.904C101.831 45.6231 97.9118 47.1518 93.8249 47.1538V47.1538Z",
    stroke: "#26FF7B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9993 22.5384H72.3086V15.5006C72.3086 11.6548 70.5492 7.96647 67.4174 5.24707C64.2857 2.52766 60.0381 0.999929 55.6091 0.999929L32.3086 0.999929V8.03769C32.3086 11.8822 34.0668 15.5694 37.1967 18.2885C40.3265 21.0077 44.5718 22.5364 48.9993 22.5384V22.5384Z",
    stroke: "#26FF7B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeepMobile);
export default __webpack_public_path__ + "static/media/deep-mobile.e50aea2d.svg";
export { ForwardRef as ReactComponent };